export default __webpack_public_path__ + "static/media/Theme.67bd0af1.jpg";